import { lazy } from "react";
const AdminArticles = lazy(() => import("../pages/admin/AdminArticles"));
const NewArticle = lazy(() => import("../pages/admin/NewArticle"));
const EditArticle = lazy(() => import("../pages/admin/EditArticle"));

export const articlesRoutes = [
  {
    path: "/admin/articles",
    component: AdminArticles,
  },
  {
    path: "/admin/articles/new",
    component: NewArticle,
  },
  {
    path: "/admin/articles/:id/edit",
    component: EditArticle,
  },
];
